import { render, staticRenderFns } from "./Apublishing.vue?vue&type=template&id=6864f214&scoped=true&"
import script from "./Apublishing.vue?vue&type=script&lang=js&"
export * from "./Apublishing.vue?vue&type=script&lang=js&"
import style0 from "./Apublishing.vue?vue&type=style&index=0&id=6864f214&lang=less&scoped=true&"
import style1 from "./Apublishing.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6864f214",
  null
  
)

export default component.exports